<div (click)="onClickPreviousMonth()" class="text-center">
  <span class="ubicon-up-arrow icon-md cursor-pointer"></span>
</div>
<ngb-datepicker #dp (dateSelect)="onDateSelection($event)" [displayMonths]="displayMonths" [dayTemplate]="t"
  [outsideDays]="'hidden'" navigation="none" formControlName="date" [minDate]="minDate" [maxDate]="maxDate"
  [(ngModel)]="selectedDate" [markDisabled]="markDisabled" class="custome-datepicker">
</ngb-datepicker>
<ng-template #t let-date let-focused="focused">
  @if (color === 'blue') {
    <span class="custom-day" [class.range]="isRange(date)"
      [class.faded]="isHovered(date) || isInside(date)" [class.gray]="isfuture(date) || isPast(date) || isNonSelectableDate(date)"
      (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
      {{ date.day }}
    </span>
  }
  @if (color === 'yellow') {
    <span class="yellow-day" [class.range]="isRange(date)"
      [class.faded]="isHovered(date) || isInside(date)" [class.gray]="isfuture(date) || isPast(date) || isNonSelectableDate(date)"
      (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
      {{ date.day }}
    </span>
  }
</ng-template>
<div (click)="onClickNextMonth()" class="text-center">
  <span class="ubicon-down-arrow icon-md cursor-pointer"></span>
</div>
